module.exports = __webpack_public_path__ + "static/media/key.ebc8ea29.svg";